"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleOrder = void 0;
var jump_1 = require("./jump");
// params 包含 isAllFinishedOrder 之前的参数用作兜底，queryMultipleOrderByPatientAndDoctor 只需要doctorId，后续稳定后可删除多余的参数
// onWarn 是兜底，即重复下单之前的逻辑，后续稳定可删除相关代码(包括之前的老逻辑)
function multipleOrder(api_1) {
    return __awaiter(this, arguments, void 0, function (api, // api的对象，需要包含 queryMultipleOrderByPatientAndDoctor 这个请求，用来检查是否有问诊单合状态及文案
    isAllFinishParams, // 参数，至少需要doctorId，其他参数可拓展，错误时作为兜底
    onNoMultiple, // 当没有进行中问诊单，走正常流程时调用
    onGoLinkBefore, // 在有进行中问诊或者待支付的时候，需要跳页面，在跳转之前调用
    onWarn, trySuccessWhenWarn, // 在报错时，默认为成功即认为没有进行中的单子
    toToast, // toast定制化处理
    toConfirm, // 弹窗的定制化处理
    onPureFun, // 在弹窗或者toast时需要重制一些信息，比如loading状态之类，调用此方法
    forceNotAutoJump // 强制不进行跳转（用于im）
    ) {
        var doctorId, afterIm, extendInfo_1, _a, otherRequestParams, param, res_1, _b, _c, multipleOrderType, url_1, serviceText, text, goLink_1, msg, e_1;
        var _this = this;
        var _d, _e;
        if (isAllFinishParams === void 0) { isAllFinishParams = {}; }
        if (trySuccessWhenWarn === void 0) { trySuccessWhenWarn = true; }
        if (forceNotAutoJump === void 0) { forceNotAutoJump = false; }
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 20, , 28]);
                    doctorId = isAllFinishParams.doctorId, afterIm = isAllFinishParams.afterIm, extendInfo_1 = isAllFinishParams.extendInfo, _a = isAllFinishParams.otherRequestParams, otherRequestParams = _a === void 0 ? {} : _a;
                    param = __assign(__assign({}, otherRequestParams), { doctorId: doctorId });
                    if (afterIm !== undefined) {
                        param.afterIm = afterIm;
                    }
                    return [4 /*yield*/, (api === null || api === void 0 ? void 0 : api.queryMultipleOrderByPatientAndDoctor(param))];
                case 1:
                    res_1 = _f.sent();
                    if (!(res_1.code === "0000")) return [3 /*break*/, 11];
                    _b = res_1.data || {}, _c = _b.multipleOrderType, multipleOrderType = _c === void 0 ? 2 : _c, url_1 = _b.url, serviceText = _b.text;
                    text = serviceText;
                    goLink_1 = function (forceNotJump) { return __awaiter(_this, void 0, void 0, function () {
                        var hyEntryStr, pureCurlAim, curl, pureCurl, jurl;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!url_1) return [3 /*break*/, 4];
                                    if (!onGoLinkBefore) return [3 /*break*/, 3];
                                    if (!(onGoLinkBefore instanceof Promise)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, onGoLinkBefore(res_1)];
                                case 1:
                                    _b.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    onGoLinkBefore(res_1);
                                    _b.label = 3;
                                case 3:
                                    if (forceNotJump) {
                                        return [2 /*return*/];
                                    }
                                    if (extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.jumpFun) {
                                        // 自定义跳转方法，用于rn
                                        (_a = extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.jumpFun) === null || _a === void 0 ? void 0 : _a.call(extendInfo_1, url_1);
                                        return [2 /*return*/];
                                    }
                                    hyEntryStr = "hy_entry=";
                                    pureCurlAim = url_1.split(hyEntryStr)[0];
                                    curl = window.location.href;
                                    pureCurl = curl.split(hyEntryStr)[0];
                                    if (pureCurl === pureCurlAim) {
                                        return [2 /*return*/];
                                    }
                                    jurl = (0, jump_1.JUMP_UNKNOW_URL)(url_1);
                                    window.location.href = jurl;
                                    _b.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!(multipleOrderType === 0)) return [3 /*break*/, 5];
                    if (extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.getToastText) {
                        text = (_d = extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.getToastText) === null || _d === void 0 ? void 0 : _d.call(extendInfo_1, serviceText);
                    }
                    if (!text) return [3 /*break*/, 2];
                    onPureFun && onPureFun(res_1);
                    toToast === null || toToast === void 0 ? void 0 : toToast({
                        duration: 3000,
                        content: text,
                        afterClose: function () {
                            goLink_1(forceNotAutoJump);
                        },
                        res: res_1,
                        jumpUrl: url_1,
                    });
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, goLink_1(forceNotAutoJump)];
                case 3:
                    _f.sent();
                    _f.label = 4;
                case 4: return [3 /*break*/, 10];
                case 5:
                    if (!(multipleOrderType === 2)) return [3 /*break*/, 9];
                    if (!onNoMultiple) return [3 /*break*/, 8];
                    if (!(onNoMultiple instanceof Promise)) return [3 /*break*/, 7];
                    return [4 /*yield*/, onNoMultiple(res_1)];
                case 6:
                    _f.sent();
                    return [3 /*break*/, 8];
                case 7:
                    onNoMultiple(res_1);
                    _f.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    if (multipleOrderType === 1) {
                        if (extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.getConfirmText) {
                            text = (_e = extendInfo_1 === null || extendInfo_1 === void 0 ? void 0 : extendInfo_1.getConfirmText) === null || _e === void 0 ? void 0 : _e.call(extendInfo_1, serviceText);
                        }
                        onPureFun && onPureFun(res_1);
                        toConfirm === null || toConfirm === void 0 ? void 0 : toConfirm({
                            title: "",
                            content: text,
                            onCancel: undefined,
                            onOk: function () {
                                goLink_1();
                            },
                            res: res_1,
                            jumpUrl: url_1,
                        });
                    }
                    _f.label = 10;
                case 10: return [2 /*return*/, res_1];
                case 11:
                    if (res_1.code === "201072") {
                        onPureFun && onPureFun(res_1);
                        toToast === null || toToast === void 0 ? void 0 : toToast({
                            duration: 2000,
                            content: "医生当前忙碌，您可选择其他医生",
                            res: res_1,
                            jumpUrl: undefined,
                        });
                        return [2 /*return*/, res_1];
                    }
                    _f.label = 12;
                case 12:
                    msg = res_1.msg || "请求异常";
                    console.log("queryMultipleOrderByPatientAndDoctor", msg);
                    if (!trySuccessWhenWarn) return [3 /*break*/, 16];
                    if (!onNoMultiple) return [3 /*break*/, 15];
                    if (!(onNoMultiple instanceof Promise)) return [3 /*break*/, 14];
                    return [4 /*yield*/, onNoMultiple(res_1, true)];
                case 13:
                    _f.sent();
                    return [3 /*break*/, 15];
                case 14:
                    onNoMultiple(res_1, true);
                    _f.label = 15;
                case 15: return [3 /*break*/, 19];
                case 16:
                    if (!onWarn) return [3 /*break*/, 19];
                    if (!(onWarn instanceof Promise)) return [3 /*break*/, 18];
                    return [4 /*yield*/, onWarn(isAllFinishParams, res_1)];
                case 17:
                    _f.sent();
                    return [3 /*break*/, 19];
                case 18:
                    onWarn(isAllFinishParams, res_1);
                    _f.label = 19;
                case 19: return [2 /*return*/, res_1];
                case 20:
                    e_1 = _f.sent();
                    if (!trySuccessWhenWarn) return [3 /*break*/, 24];
                    if (!onNoMultiple) return [3 /*break*/, 23];
                    if (!(onNoMultiple instanceof Promise)) return [3 /*break*/, 22];
                    return [4 /*yield*/, onNoMultiple(undefined, true)];
                case 21:
                    _f.sent();
                    return [3 /*break*/, 23];
                case 22:
                    onNoMultiple(undefined, true);
                    _f.label = 23;
                case 23: return [3 /*break*/, 27];
                case 24:
                    if (!onWarn) return [3 /*break*/, 27];
                    if (!(onWarn instanceof Promise)) return [3 /*break*/, 26];
                    return [4 /*yield*/, onWarn(isAllFinishParams)];
                case 25:
                    _f.sent();
                    return [3 /*break*/, 27];
                case 26:
                    onWarn(isAllFinishParams);
                    _f.label = 27;
                case 27:
                    onPureFun && onPureFun(undefined);
                    return [3 /*break*/, 28];
                case 28: return [2 /*return*/];
            }
        });
    });
}
exports.multipleOrder = multipleOrder;
